
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { UUID } from 'angular2-uuid';
import { Router } from '@angular/router';

import { AuthService } from './services/auth.service';
import { BaseService } from './services/base.service';
import { LoadingService } from './services/loading.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private baseService: BaseService,
    private loadingService: LoadingService,
    private router: Router,
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = req.url;
    const uuid = UUID.UUID();
    // Temporary solution to hide loading bar for specific endpoint
    const hideLoadingBar = [
      'Payment/PaymentDetail/Installments',
      'investors/me/portfolio/detail',
      'bbs/ext/digital-signature-session/submit/id',
      'ees/ext/digital-signature-session/submit/id',
    ];
    const hideLoadingBarInvestor = (window.location.pathname.includes('/admin-investor/portfolio') &&
      hideLoadingBar.some(v => url.includes(v)));
    const hideLoadingBarBorrower = (window.location.pathname.includes('/admin-borrower/repayment') &&
      hideLoadingBar.some(v => url.includes(v)));
    const hideLoadingBarInvestorOverview = window.location.pathname.includes('/admin-investor/overview');

    const showLoadingBar = !(hideLoadingBarInvestor || hideLoadingBarBorrower || hideLoadingBarInvestorOverview) && !url.includes('/mobile_login/oauth/token');

    if (showLoadingBar) {
      this.loadingService.beforeRequest.emit(uuid);
    }
    return next.handle(req).pipe(
      tap(evt => {
        if (showLoadingBar && evt instanceof HttpResponse) {
          this.loadingService.afterRequest.emit(uuid);
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          const expiryTime = this.authService.getExpiryTime();
          const sessionAbleToRefresh = expiryTime !== '' && this.authService.getRememberMe();
          const omitError = (err.url.indexOf('/mobile_login/oauth/token') >= 0);
          if (!omitError && err.status === 401 && !sessionAbleToRefresh) {
            this.authService.logOut();
            this.router.navigate(['/log-in']);
          }
          if (showLoadingBar) {
            this.loadingService.afterRequest.emit(uuid);
          }
        }
        return this.baseService.errorHandler(err);
      }));
  }

}
